import { render, staticRenderFns } from "./ModalRejectRefund.vue?vue&type=template&id=16db07b4&"
import script from "./ModalRejectRefund.vue?vue&type=script&lang=js&"
export * from "./ModalRejectRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports